import Vuex from 'vuex'
import Vue from 'vue'

// set up application to use Vuex (application state management)
Vue.use(Vuex)

// set up the application state accessible by all components
const store = new Vuex.Store({
  state: {
    authenticated: false,
    authToken: {},
    authenticationError: '',
    authenticationStackTrace: '',
    person: {},
    personFetchError: '',
    personFetchStackTrace: '',
    recentPurchases: [],
    expiringLicenses: [],
    localeJson: JSON.stringify({}),
    licenseDetails: {},
    previousPath: '/',
    isLA007User: false,
    isSurveyModalInteracted: false,
    isSurveyModalInteractedXS: false,
    validSurveyURL: false,
    validXSSurveyURL: false,
    validSurveyData: {},
    validXSSurveyData: {},
    surveyUrl: '',
    surveyId: '',
    xsSurveyId: '',
    xsSurveyUrl: '',
    showSurveyModal: false,
    showSurveyModalXS: false,
    showSurveyModaltemplate: false,
    xsskeyWords: ['cookie', 'document', 'script', 'javascript', 'src', 'iframe', 'svg', 'location', 'href', 'confirm', 'http', 'https'],
    isTokenAPICalled: false,
    isPersonInRole: false,
    isAllowPartialForWebKey: false,
    UberAgentDetails: [],
    DeviceTrustDetails: [],
    StrongLicDetails: [],
    UniconLicDetails: [],
    nsLicType: ['uberAgent', 'deviceTrustLic', 'strongLic']
  },
  getters: {
    authenticated: state => state.authenticated,
    authToken: state => state.authToken,
    authenticationError: state => ({
      errorMessage: state.authenticationError,
      errorStack: state.authenticationStackTrace
    }),
    person: state => state.person,
    personFetchError: state => ({
      errorMessage: state.personFetchError,
      errorStack: state.personFetchStackTrace
    }),
    recentPurchases: state => state.recentPurchases,
    expiringLicenses: state => state.expiringLicenses,
    localeJson: state => state.localeJson,
    licenseDetails: state => state.licenseDetails,
    previousPath: state => state.previousPath,
    isLA007User: state => state.isLA007User,
    isSurveyModalInteracted: state => state.isSurveyModalInteracted,
    isSurveyModalInteractedXS: state => state.isSurveyModalInteractedXS,
    validSurveyURL: state => state.validSurveyURL,
    validXSSurveyURL: state => state.validXSSurveyURL,
    validSurveyData: state => ({
      Id: state.surveyId,
      Url: state.surveyUrl
    }),
    validXSSurveyData: state => ({
      Id: state.xsSurveyId,
      Url: state.xsSurveyUrl
    }),
    showSurveyModal: state => state.showSurveyModal,
    showSurveyModalXS: state => state.showSurveyModalXS,
    showSurveyModaltemplate: state => state.showSurveyModaltemplate,
    xsskeyWords: state => state.xsskeyWords,
    hasXssKeyWord: (state) => (hostValue) => {
      let remSpace = /\s\s+/g
      var hostUnesc = unescape(hostValue).toLowerCase().replace(remSpace, ' ')
      var arr = hostUnesc.trim().split(/[\s='"<>();:/\\’”&%(){}.*?@-`]+/)
      return state.xsskeyWords.some(v => arr.some(c => c === v))
    },
    isTokenAPICalled: state => state.isTokenAPICalled,
    isPersonInRole: state => state.isPersonInRole,
    isAllowPartialForWebKey: state => state.isAllowPartialForWebKey,
    UberAgentDetails: state => state.UberAgentDetails,
    DeviceTrustDetails: state => state.DeviceTrustDetails,
    StrongLicDetails: state => state.StrongLicDetails,
    UniconLicDetails: state => state.UniconLicDetails,
    nsLicType: state => state.nsLicType
  },
  mutations: {
    authenticated (state, payload) {
      state.authenticated = payload.authenticated
      state.authToken = payload.token
    },
    personFetched (state, payload) {
      state.person = payload.person
    },
    personFetchFailure (state, payload) {
      state.personFetchError = payload.errorMessage
      state.personFetchStackTrace = payload.errorStack
    },
    authenticationFailure (state, payload) {
      state.authenticated = false
      state.authenticationError = payload.errorMessage
      state.authenticationStackTrace = payload.errorStack
    },
    setLicenseItems (state, payload) {
      state[payload.itemType] = payload.items
    },
    setLocaleJson (state, localeJson) {
      state.localeJson = localeJson
    },
    setCustomerId (state, customerId) {
      state.person.customerId = customerId
    },
    setUberAgentDetails (state, UADetails) {
      state.UberAgentDetails = UADetails
    },
    setDeviceTrustDetails (state, DeTrustDetails) {
      state.DeviceTrustDetails = DeTrustDetails
    },
    setStrongLicDetails (state, StLicDetails) {
      state.StrongLicDetails = StLicDetails
    },
    setUniconLicDetails (state, UcLicDetails) {
      state.UniconLicDetails = UcLicDetails
    },
    setLicenseDetails (state, licenseDetails) {
      state.licenseDetails = licenseDetails
    },
    setPreviousPath (state, previousPath) {
      state.previousPath = previousPath
    },
    setLA007User (state, payload) {
      state.isLA007User = payload.value
    },
    SURVEY_MODAL_CLOSED (state, payload) {
      state.isSurveyModalInteracted = payload
    },
    SURVEY_MODAL_CLOSED_XS (state, payload) {
      state.isSurveyModalInteractedXS = payload
    },
    VALID_SURVEY_DATA (state, payload) {
      state.surveyId = payload.surveyId
      state.surveyUrl = payload.surveyUrl
      if (payload.surveyUrl !== undefined) {
        state.validSurveyURL = true
      }
    },
    VALID_SURVEY_DATA_XS (state, payload) {
      state.xsSurveyId = payload.xsSurveyId
      state.xsSurveyUrl = payload.xsSurveyUrl
      if (payload.xsSurveyUrl !== undefined) {
        state.validXSSurveyURL = true
      }
    },
    SHOW_SURVEY_MODAL (state, payload) {
      state.showSurveyModal = payload
    },
    SHOW_SURVEY_MODAL_XS (state, payload) {
      state.showSurveyModalXS = payload
    },
    SHOW_SURVEY_MODAL_TEMPLATE (state, payload) {
      state.showSurveyModaltemplate = payload
    },
    IS_TOKEN_API_CALLED (state, payload) {
      state.isTokenAPICalled = payload
    },
    IS_PERSON_IN_ROLE (state, payload) {
      state.isPersonInRole = payload
    },
    IS_ALLOW_PARTIAL_FOR_WEB_KEY (state, payload) {
      state.isAllowPartialForWebKey = payload
    }
  },
  actions: {
    authenticate (context, payload) {
      let loginId = payload.loginId || ''
      return payload.authService.authenticate(payload.authURL, loginId, payload.authCookie).then(res => {
        const authToken = payload.authService.getAuthenticatedUser()
        Vue.AppInsights.setAuthenticatedUserContext(authToken.userName, authToken.customerId, true)
        // trigger the state mutation
        context.commit('authenticated', {
          authenticated: true,
          token: authToken
        })

        context.commit('IS_TOKEN_API_CALLED', false)
      })
      .catch(err => {
        // trigger authentication error state mutation
        context.commit('authenticationFailure', {
          errorMessage: err.message,
          errorStack: err.stack
        })
      })
    },
    fetchPerson (context, payload) {
      return payload.bottle.get(payload.personUrl).then(res => {
        // trigger state mutation
        context.commit('personFetched', {
          person: res.data
        })
      })
      .catch(err => {
        // trigger person fetch error state mutation
        context.commit('personFetchFailure', {
          errorMessage: err.message,
          errorStack: err.stack
        })
      })
    },
    fetchLicenseItems (context, payload) {
      return payload.bottle.get(payload.url)
        .then(({ data }) => {
          context.commit('setLicenseItems', {
            itemType: payload.itemType,
            items: Array.isArray(data) ? data : []
          })
        })
    },
    fetchLocaleJson (context, payload) {
      return payload.bottle.get(payload.url)
        .then(({ data }) => context.commit('setLocaleJson', data))
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js